import React from 'react'
import { Formik, Form } from 'formik'
import useQuery from 'hooks/useQuery'
import Select from 'components/common/Formik/Select'
import { Button } from '@mui/material'
import InputField from '../../common/Formik/InputField'

function IdentifyForm({
  initialValues,
  validationSchema,
  onSubmitForm,
  isSubmitting,
}) {
  const { data } = useQuery({ defaultEndpoint: '/specialities' })
  return (
    <div className='flex-1 mt-[10vh] mx-auto w-full'>
      <div
        className='flex bg-gray-100 rounded-lg shadow-2xl overflow-hidden
         mx-auto max-w-xs md:max-w-lg lg:max-w-xl'
      >
        <div className='w-full p-8 bg-purple-50'>
          <h1 className='mb-8 text-2xl font-semibold text-gray-600 text-center'>
            Ingrese sus datos
          </h1>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) => onSubmitForm(values)}
            validateOnBlur={false}
            validateOnChange={false}
          >
            <Form>
              <div className='flex flex-col justify-center gap-4'>
                <InputField label='Nombre/s' name='firstName' />
                <InputField label='Apellido/s' name='lastName' />
                <Select name='speciality' options={data?.specialities} />
                <div className='m-2'>
                  <Button
                    className='bg-indigo-500 text-white font-bold py-2 px-4 w-full rounded-lg hover:bg-indigo-400'
                    type='submit'
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Cargando...' : 'Ingresar'}
                  </Button>
                </div>
              </div>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  )
}

export default IdentifyForm
